import type { SuggestedAction } from '@/data/chat/chat';

import { TOUR_TRIGGER_ACTION } from '@/lib/chat/tour-protocol';

/**
 * Injected client-side (never LLM-generated) so the trigger phrase stays
 * byte-stable for the chat system prompt's guided-tour section and the chip
 * also shows when suggestions fall back.
 */
export const TOUR_SUGGESTION: SuggestedAction = {
  title: 'Tour this PR',
  action: TOUR_TRIGGER_ACTION,
  kind: 'navigate',
};

export const FALLBACK_SUGGESTIONS: SuggestedAction[] = [
  {
    title: 'Show me the riskiest change',
    action:
      'Show me where the riskiest change in this PR is and explain why it deserves attention first.',
    kind: 'navigate',
  },
  {
    title: 'Walk me through the high-level changes.',
    action: "Explain the PR's intent, main code paths, and high-level behavior changes.",
    kind: 'question',
  },
  {
    title: 'What failure mode is easiest to miss?',
    action:
      'Identify the likeliest failure mode, missing state, or permission boundary to pressure-test.',
    kind: 'question',
  },
];

/**
 * Whether a suggestion chip navigates the user to code when clicked.
 *
 * The explicit `kind` from the generator wins; the title-prefix fallback covers
 * payloads generated before `kind` existed (stale cache, rolling deploy) and
 * model omissions of the optional field.
 */
export function isNavigationSuggestion(
  suggestion: Pick<SuggestedAction, 'title' | 'kind'>,
): boolean {
  if (suggestion.kind) {
    return suggestion.kind === 'navigate';
  }

  return /^show me\b/i.test(suggestion.title.trim());
}
